import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import PropTypes from 'prop-types';
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken, user_location } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Swal from 'sweetalert2';

const ProductionStocks = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [berriesforyou, setBerriesforyou] = useState([]);
  const [dirafrost, setDirafrost] = useState([]);
  const [mondialberry, setMondialberry] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(453));
    axios.post("/production-output/stocks", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } }).
      then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.stocks);
          setBerriesforyou(response.data.data.location_Berries_For_You);
          setDirafrost(response.data.data.location_Dirafrost);
          setMondialberry(response.data.data.location_Mondial_Berry);

        }
      }).catch((error) => {
        console.log(error);
      });

  }, []);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  const updateDate = async (id, type) => {
    console.log(type);

    const { value: formValues } = await Swal.fire({
      title: 'Real Quantity In Stock',
      // html: `
      //   <input type="number" id="real_quantity" placeholder="Enter Stock" class="swal2-input">
      //   <input type="date" id="datePicker" class="swal2-input" style="margin-top: 10px;">
      // `,
      html: `
      <div style="display: grid;">
        <input type="hidden" value="${id}" id="setting_id" class="swal2-input">
        
        <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;">Enter Quantity</label>
        <input type="number" id="real_quantity" value="" class="swal2-input" placeholder="Enter Quantity">
        
        <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;">Update Date</label>
        <input type="date" id="datePicker"  class="swal2-input" placeholder="Select Date">
        
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      preConfirm: () => {
        const real_quantity = document.getElementById('real_quantity').value;
        const selectedDate = document.getElementById('datePicker').value;

        // Validation
        if (!real_quantity || !selectedDate) {
          Swal.showValidationMessage('Please fill in all fields');
          return false;
        }

        return {
          real_quantity: real_quantity,
          date: selectedDate
        };
      }
    });

    if (formValues) {
      console.log('Selected decay_weight:', formValues.real_quantity);
      console.log('Selected date:', formValues.date);

      let season_id = 1;

      axios.post(`/production-output/update-stock`, {
        season_id: season_id,
        id: id,
        real_quantity: formValues.real_quantity,
        update_date: formValues.date
      }, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken
        },
      })
        .then((response) => {
          console.log(response);
          Swal.fire(
            'Deleted!',
            'Your Record has been deleted.',
            'success'
          );
          setTimeout(() => {
            axios.post("/production-output/stocks-realtime", {}, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken } }).
              then((response) => {
                if (response.data.code === 200) {
                  setData(response.data.data.stocks);
                  setBerriesforyou(response.data.data.location_Berries_For_You);
                  setDirafrost(response.data.data.location_Dirafrost);
                  setMondialberry(response.data.data.location_Mondial_Berry);

                }
              }).catch((error) => {
                console.log(error);
              });

          }, 500);


        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const ProductionDateCell = ({ row, permission, updateDate }) => {
    const { original } = row;

    return (
      <div>
        {permission?.update == 1 ? (
          <button
            className="btn btn-primary btn-block"
            id={`button-all-${original.id}`}
            onClick={() => updateDate(original.id, 'all')}
          >
            {original.real_quantity ?? 'Update'}
          </button>
        ) : (
          <span>{original.real_quantity ?? 'N/A'}</span>
        )}
      </div>
    );
  };


  // ✅ Define PropTypes
  ProductionDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        real_quantity: PropTypes.string,
      }).isRequired,
    }).isRequired,
    permission: PropTypes.shape({
      update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    updateDate: PropTypes.func.isRequired,
  };


  // Product link component
  const ProductGroup = ({ row }) => (
    <a href={`/production-stocks-view/${row.original.product}_${row.original.location}`}>
      {row.original.product_name ?? ""}
    </a>
  );

  ProductGroup.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        product: PropTypes.string.isRequired,
        location: PropTypes.string,
        product_name: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };

  // Location link component
  const LocationGroup = ({ row }) => (
    <a href={`/production-stocks-view/${row.original.product}_${row.original.location}`}>
      {row.original.location_name ?? ""}
    </a>
  );

  LocationGroup.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        product: PropTypes.string.isRequired,
        location: PropTypes.string,
        location_name: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };

  // Columns definition
  const columnsss = [
    {
      header: 'Product',
      accessorFn: (row) => row.product_name,
      Cell: ProductGroup,
    },
    {
      header: 'Location',
      accessorFn: (row) => row.location_name,
      Cell: LocationGroup,
    },
    {
      accessorKey: 'available_quantity',
      header: 'Available Quanity',
    },
    // {
    //   accessorKey: 'real_quantity',
    //   header: 'Real Quanity',
    // },
    {
      header: 'Real Quantity In Stock',
      accessorFn: (row) => row.real_quantity || '',
      Cell: (props) => <ProductionDateCell {...props} permission={permission} updateDate={updateDate} />,
    },
    {
      accessorKey: 'update_date',
      header: 'Update Date',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby
          ? `${row.updatedby.first_name} ${row.updatedby.last_name}`
          : '',
    },
  ];





  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Production Stocks</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Production Stocks
                    </li>
                  </ul>
                </div>

              </div>


            </div>

            <div className="row">
              <div className="col-sm-12">
                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">

                        {permission && permission.list === 1 && (
                          <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Stocks</a>
                              </li>
                              <li className="nav-item">
                                <a className={`nav-link   ${user_location == 4 ? "active" : ""}`} href="#groupby-4" data-bs-toggle="tab">Stock : Mondial Berry</a>
                              </li>
                              <li className="nav-item">
                                <a className={`nav-link   ${user_location == 6 ? "active" : ""}`} href="#groupby-6" data-bs-toggle="tab"> Stock: Berries For You</a>
                              </li>
                              <li className="nav-item">
                                <a className={`nav-link   ${user_location == 7 ? "active" : ""}`} href="#groupby-7" data-bs-toggle="tab"> Stock: Dirafrost</a>
                              </li>

                            </ul>
                            <div className="tab-content">
                              <div className={`tab-pane   ${user_location == 4 ? " show active " : ""}`} id="groupby-4">
                                <div className="row" id="listing-followup-groupby">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columnsss}
                                            data={mondialberry}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={`tab-pane   ${user_location == 6 ? " show active " : ""}`} id="groupby-6">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columnsss}
                                            data={berriesforyou}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={`tab-pane   ${user_location == 7 ? " show active " : ""}`} id="groupby-7">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable
                                            columns={columnsss}
                                            data={dirafrost}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="tab-pane" id="listing-all">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnsss} data={data}
                                            enableColumnOrdering
                                            enablePinning

                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionStocks;
